import React from 'react';
import { useNavigate } from 'react-router-dom';

import ArrowBackIcon from '../assets/arrow-back-icon';

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <span className="flex gap-4 items-center cursor-pointer" onClick={() => navigate(-1)}>
      <ArrowBackIcon />
      <span className="text-body1 md:text-[18px] leading-[150%] md:leading-[100%]">Kembali</span>
    </span>
  );
};

export default BackButton;
